import { toast, ToastOptions } from "react-toastify";

export const ToastyRed = (content: string, options?: ToastOptions) =>
  toast.error(content, options);
